import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseConfirmation } from '../components/PurchaseConfirmation';
import { UpsellCatalog } from '../components/UpsellCatalog';
import { DownloadArea } from '../components/DownloadArea';
import { Support } from '../components/Support';
import { HeartIcon } from 'lucide-react';
export function DownloadPage() {
  return <div className="min-h-screen bg-[#FDF8F3]" data-id="element-75">
      {/* Header */}
      <header className="py-4 px-4 border-b border-[#E8B4B8]/30" data-id="element-76">
        <div className="max-w-6xl mx-auto flex items-center justify-center" data-id="element-77">
          <motion.div initial={{
          y: -10,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.5
        }} className="flex items-center gap-3" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/nB1PFVF2gy44fovBFDuHb7/Diseno_sin_titulo_(5).png" alt="Kreana Crochet - Diseños de lujo" className="w-14 h-14 rounded-full object-cover" data-id="element-79" />
            <span className="text-xl font-bold text-[#3D2C2C] font-heading tracking-wide" data-id="element-80">
              KREANA CROCHET
            </span>
          </motion.div>
        </div>
      </header>

      <main data-id="element-81">
        {/* Section 1: Confirmation */}
        <PurchaseConfirmation data-id="element-82" />

        {/* Section 2 & 3: FOMO Offer & Product Grid */}
        <UpsellCatalog data-id="element-83" />

        {/* Section 4: Rejection & Download */}
        <DownloadArea data-id="element-84" />

        {/* Section 5: Support */}
        <Support data-id="element-85" />
      </main>

      {/* Footer */}
      <footer className="py-8 px-4 bg-[#3D2C2C] text-white/80" data-id="element-86">
        <div className="max-w-6xl mx-auto text-center" data-id="element-87">
          <div className="flex items-center justify-center gap-3 mb-3" data-id="element-88">
            <img src="https://cdn.magicpatterns.com/uploads/nB1PFVF2gy44fovBFDuHb7/Diseno_sin_titulo_(5).png" alt="Kreana Crochet" className="w-8 h-8 rounded-full object-cover opacity-80" data-id="element-89" />
            <span className="text-sm" data-id="element-90">Hecho con</span>
            <HeartIcon className="w-4 h-4 text-[#E8B4B8] fill-[#E8B4B8]" aria-hidden="true" data-id="element-91" />
            <span className="text-sm" data-id="element-92">por Kreana Crochet</span>
          </div>
          <p className="text-xs text-white/50" data-id="element-93">
            © 2025 Kreana Crochet — Diseños de lujo. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>
    </div>;
}